import { Type } from 'app/constants/TourPoints';
import { twisterType } from 'app/constants/twisterType.constants';
import * as e from 'app/constants/TourBuilderEvents';
import { useMediator } from '../useMediator';
import { useTimestamp } from '../../../../Utility/Service/keepTimestamp.service';

const minWrongRouteDistance = 150; // eslint-disable camelcase

const PartData = () => {
  let pointList = {};
  let pointStack = [];
  let lastViaNumber = 0;
  let latestPointsList = [];

  const [addToProgress, removeFromProgress] = useTimestamp();
  const [getMediator, setMediator, destroyMediator] = useMediator();

  const getStack = () => pointStack;
  const getList = () => pointList;
  const getCountPoints = () => pointStack.length;
  const getFirstPoint = () => pointList[pointStack[0]];
  const getLastPoint = (i = 1) => pointList[pointStack[pointStack.length - i]];
  const getIdByPosition = (index) => parseInt(pointStack[index]);
  const getPointById = (id) => {
    return pointList[id] || console.info(`Point with id ${id} is not exists`);
  };
  const getPointByPos = (index) => {
    const id = getIdByPosition(index);
    return id ? getPointById(id) : 0;
  };
  const getLastNotEmptyPoint = (index = 0) => {
    const len = index || getCountPoints();
    let lastNotEmptyPoint = null;
    for (let it = len; it-- > 0; ) {
      const point = getPointByPos(it);
      if (!point.isEmpty && !lastNotEmptyPoint) {
        lastNotEmptyPoint = point;
        break;
      }
    }

    return lastNotEmptyPoint;
  };
  const getPosition = (id) => pointStack.indexOf(id);
  const changePointToViaById = (id) => {
    pointList[id].type = Type.VIA;
    return true;
  };

  const changePointToDragById = (id) => {
    pointList[id].type = Type.DRAG;
    return true;
  };

  const getPointNumber = () => lastViaNumber++;
  const isIndexBeforeLastVia = (index) => lastViaNumber - index === 2;

  const isPointExists = (id) => (id ? pointList[id] : false);

  const isStartPointAbsent = () =>
    getCountPoints() > 1 &&
    (pointList[pointStack[0]].isEmpty ||
      pointList[pointStack[0]].type === Type.VIA);

  const isExistsStartPoint = () =>
    getFirstPoint() && !getFirstPoint().isEmpty && getFirstPoint().isStart();

  const isExistsEndPoint = () =>
    getLastPoint() && !getLastPoint().isEmpty && getLastPoint().isEnd();

  const isEmptyStartPoint = () =>
    getFirstPoint() &&
    getFirstPoint().type === Type.START &&
    getFirstPoint().isEmpty;

  const isEmptyEndPoint = () =>
    getLastPoint() &&
    getLastPoint().type === Type.END &&
    getLastPoint().isEmpty;

  const isCurrPartCompleted = () => isExistsStartPoint() || isExistsEndPoint();

  const isPointEmpty = (point) => (point ? !point.isEmpty : false);
  const hasTourPoly = () =>
    Object.values(pointList).filter(isPointEmpty).length > 1;

  const setCorrectCoord = (
    {
      id,
      correctLat,
      correctLng,
      keppCurrentCoord = 0,
      isRemoveCorrectCoord = false,
      wrongDist,
    },
    isCorrectionEnabled
  ) => {
    const point = getPointById(id);
    if (point) {
      let isKept =
        isCorrectionEnabled || keppCurrentCoord || point.keppCurrentCoord || 0;
      if (
        id &&
        typeof correctLat === 'number' &&
        typeof correctLng === 'number'
      ) {
        point.setCorrectCoord({
          correctLat,
          correctLng,
          keppCurrentCoord: isKept,
          wrongDist,
        });
      }
      if (isRemoveCorrectCoord) {
        isKept = isCorrectionEnabled && keppCurrentCoord;
        point.setCorrectCoord({
          correctLat: undefined,
          correctLng: undefined,
          isKept,
          wrongDist: 0,
        });
      }
    } else {
      console.log(
        id,
        correctLat,
        correctLng,
        keppCurrentCoord,
        isRemoveCorrectCoord,
        wrongDist,
        isCorrectionEnabled
      );
      console.log(pointStack, pointList);
    }
  };
  const getPointTypeById = (id) => {
    let type = '';
    const point = getPointById(id);
    if (point && typeof point.getType === 'function') {
      type = point.getType();
    }
    return type;
  };
  const isAutoCorrectionAvailable = (
    { keppCurrentCoord, type },
    isVia,
    isDrag
  ) =>
    !keppCurrentCoord &&
    ((type === Type.VIA && isVia) || (type === Type.DRAG && isDrag));
  const onlyPointsWithShortestWrongDist = (isVia, isDrag) => {
    pointStack.forEach((id) => {
      const point = getPointById(id);
      if (point.wrongDist && point.wrongDist < minWrongRouteDistance) {
        if (isAutoCorrectionAvailable(point, isVia, isDrag)) {
          getMediator().notify(e.TB_MAP_AUTOCORRECT_POINT_COORD, { ...point });
        }
      }
    });
  };
  const updateAllPointsRelation = (isEnabled, type) => {
    pointStack.forEach((id) => {
      const point = getPointById(id);
      if (
        (!type || point.type === type) &&
        !point.isEmpty &&
        (point.correctLat || point.correctLng)
      ) {
        point.keepCurrentCoord(!isEnabled);
      }
    });
  };

  const upPointOnMap = (point) =>
    getMediator().notify(e.TB_UP_POINT_ON_MAP, { ...point });

  const showPointOnMap = (point) =>
    getMediator().notify(e.TB_CREATE_POINT_ON_MAP, { ...point });

  const updatePointPolyOnMap = (
    point,
    isFixed = false,
    isLoading = false,
    isWithoutReverse = false
  ) => {
    return point
      ? getMediator().notify(e.TB_UP_POLY_ON_MAP_BY_POINT_ID, {
          id: point.getId(),
          isFixed,
          isLoading,
          isWithoutReverse,
          isRemoved: point.isRemoved,
        })
      : null;
  };

  const getPrevPoint = (point) => {
    const pos = point.getId ? getPosition(point.getId()) : point;
    if (pos < 0) return null;

    const prevPoint = getPointByPos(pos - 1);

    if (prevPoint && prevPoint.isEmpty) {
      return getPrevPoint(prevPoint);
    }
    return prevPoint;
  };

  const getNextPoint = (point) => {
    const pos = point.getId ? getPosition(point.getId()) : point;
    if (pos >= getCountPoints()) return null;

    const nextPoint = getPointByPos(pos + 1);

    if (nextPoint && nextPoint.isEmpty) {
      return getNextPoint(nextPoint);
    }
    return nextPoint;
  };

  const correctPointsPositions = () => {
    pointStack.forEach((id) => {
      const point = getPointById(id);
      const { isEmpty, correctLat, correctLng } = point;
      if (
        !isEmpty &&
        point.isWrongCoord() &&
        correctLat !== 0 &&
        correctLng !== 0
      ) {
        point.correctPointPosition(correctLat, correctLng);
        upPointOnMap(point);
        updatePointPolyOnMap({ ...point }, true);
        const prevPoint = getPrevPoint(point);
        if (prevPoint) {
          prevPoint.setNextId(point.getId());
          point.setPrevId(prevPoint.getId());
          point.setPrevCoordStr(prevPoint.getCoordStr());
          upPointOnMap(point);
          updatePointPolyOnMap({ ...prevPoint }, true);
        }
        const nextPoint = getNextPoint(point);
        if (nextPoint) {
          point.setNextId(nextPoint.getId());
          nextPoint.setPrevId(point.getId());
          nextPoint.setPrevCoordStr(point.getCoordStr());
          updatePointPolyOnMap({ ...nextPoint }, true);
          upPointOnMap(point);
        }
      }
    });
  };

  const cleanPrevCoord = (point) => {
    point.setPrevCoordStr('');
    point.setPrevId(0);
  };

  const setPointSiblings = (point, index) => {
    if (!point) return;
    const prevPoint =
      typeof index === 'number' ? getPointByPos(index) : getPrevPoint(point); // getPointByPos( index ) was not tested
    if (prevPoint) {
      point.setPrevCoordStr(prevPoint.getCoordStr()); // prevPoint always the same!!!
      point.setPrevId(prevPoint.id);
      prevPoint.setNextId(point.id);
    } else if (prevPoint === 0) {
      // point will have type START
      cleanPrevCoord(point);
    }
  };

  const setCoordRelation = (
    { customId, keepCurrentCoord },
    isCorrectionEnabled
  ) => {
    const point = getPointById(customId);
    const isKeeped = isCorrectionEnabled && keepCurrentCoord;
    point.keepCurrentCoord(isKeeped);
  };

  const getNextPointType = () => (isStartPointAbsent() ? Type.START : Type.VIA);

  const removePointById = (id) => {
    const pos = getPosition(id);
    if (pos > -1) pointStack.splice(pos, 1);
    delete pointList[id];
  };

  const removePointPolyOnMap = (id) => {
    getMediator().notify(e.TB_REMOVE_POINT_ON_MAP_BY_ID, id);
  };

  const addStartPoint = (startPoint) => {
    if (isExistsStartPoint()) {
      const firstId = getFirstPoint().getId();
      removePointPolyOnMap(firstId);
      removePointById(firstId);
    }

    if (isEmptyStartPoint()) {
      removePointById(getFirstPoint().getId());
    }

    pointList[startPoint.id] = startPoint;
    pointStack.unshift(startPoint.id);
  };
  const addEndPoint = (endPoint) => {
    if (isEmptyEndPoint()) removePointById(getLastPoint().getId());

    pointList[endPoint.id] = endPoint;
    pointStack.push(endPoint.id);
  };

  const addMiddlePoint = (middlePoint, index, isLastVia, isStaightIndex) => {
    // if(!isExistsEndPoint() && isEmptyEndPoint() && pointStack.length === 3 && !pointList[pointStack[1]].isEmpty ){
    //     removePointById( getLastPoint().getId() );
    //     removeEmptyPoints();
    // }
    const id = middlePoint.getId();
    pointList[id] = middlePoint;

    if (pointStack.length === 3 && pointList[pointStack[1]].isEmpty === true) {
      pointStack.splice(1, 1, id);
    } else if (
      !isExistsEndPoint() &&
      !isStaightIndex &&
      middlePoint.getType() !== Type.DRAG
    ) {
      pointStack.push(id);
    } else if (typeof index === 'number') {
      pointStack.splice(index + 1, 0, id);
    } else if (isEmptyEndPoint() && !isEmptyStartPoint()) {
      pointStack.splice(-1, 0, id);
    }
    // else if (!isEmptyEndPoint() && !isEmptyStartPoint()) {
    //   pointStack.splice(-1, 0, id);
    // }
    else {
      pointStack.push(id);
    }
  };

  const setNextPointCoord = (point) => {
    const nextPoint = getNextPoint(point);
    if (nextPoint) {
      point.setNextId(nextPoint.getId());
    }
  };

  const upPointOnList = () =>
    getMediator().notify(e.TB_SAVE_PART_DATA_IN_REDUX);

  const upPointsWithTimestamp = () => {
    const timestamp = removeFromProgress();
    if (timestamp) {
      getMediator().notify(e.TB_SAVE_PART_DATA_IN_REDUX_USE_TIMESTAMP, {
        timestamp,
      });
    } else {
      upPointOnList();
    }
  };

  const updateLatestPointHistory = (data, loc) =>
    getMediator().notify(e.TB_SAVE_LATEST_POINT_HISTORY, { ...data, loc });

  const refreshAddressPointById = (id) => {
    addToProgress();
    getPointById(id).refreshAddress(
      upPointsWithTimestamp,
      updateLatestPointHistory
    );
  };

  const setPlaceInfo = (id) => {
    addToProgress();
    getPointById(id).getInfoFromPlace(upPointsWithTimestamp);
  };

  const upMapPointAfterStickToRoad = (point) => {
    if (
      !!point &&
      typeof point.getCoordStr === 'function' &&
      typeof point.getPrevCoordStr === 'function'
    ) {
      if (point.getCoordStr() === point.getPrevCoordStr()) {
        const { id } = point;
        removePointById(id);
        removePointPolyOnMap(id);
      } else {
        upPointOnMap(point); // was uncomented
      }
    }
  };

  const stickToRoadPointById = (id) =>
    getPointById(id).stickToRoad(upMapPointAfterStickToRoad);

  const uploadAdditionalPointData = (point) => {
    if (!point.isEmpty) {
      if (!point.address) refreshAddressPointById(point.getId());
      if (point.isNotStickedToRoad) stickToRoadPointById(point.getId());
      if (point.place_id) setPlaceInfo(point.getId());
    }
  };

  const updatePointsPrevCoord = () => {
    let prevCoord = '';
    let prevId = 0;
    getStack().forEach((id) => {
      const point = getPointById(id);
      if (!point.isEmpty) {
        point.setPrevCoordStr(prevCoord);
        point.setPrevId(prevId);
        prevCoord = point.getCoordStr();
        prevId = point.id;
      }
    });

    const listIds = getStack().slice();
    listIds.reverse();
    let nextId = 0;
    listIds.forEach((id) => {
      const point = getPointById(id);
      if (!point.isEmpty) {
        point.setNextId(nextId);
        nextId = id;
      }
    });
  };

  const addPointByType = (point, index, isLastVia, isStaightIndex) => {
    setPointSiblings(point, index);
    switch (point.type) {
      case Type.START:
        addStartPoint(point);
        break;
      case Type.END:
        addEndPoint(point);
        break;
      default:
        addMiddlePoint(point, index, isLastVia, isStaightIndex);
    }
    setNextPointCoord(point);
    uploadAdditionalPointData(point);
    updatePointsPrevCoord();
  };

  const setEmptyPoint = (type) =>
    getMediator().notify(e.TB_SET_EMPTY_POINT, { type });

  const wasPolyChanged = (historyPt) => {
    // the function is not work correctly
    if (historyPt) {
      const point = getPointById(historyPt.getId());
      if (
        !point ||
        !historyPt ||
        point.getCoordStr() !== historyPt.getCoordStr() ||
        point.getPrevCoordStr() !== historyPt.getPrevCoordStr() ||
        point.type === Type.START ||
        historyPt.type === Type.START
      ) {
        return false;
      }
    }
    return true;
  };

  const getExcessPoints = (listPointsWithPermission) => {
    const excessPointIds = [];
    for (let id in pointList) {
      if ({}.hasOwnProperty.call(pointList, id)) {
        id = parseInt(id);
        if (listPointsWithPermission.indexOf(id) === -1) {
          excessPointIds.push(id);
        }
      }
    }
    return excessPointIds;
  };

  const getImaginePosition = (newPoint, clotherPoint, getDistance) => {
    const { point, pos } = clotherPoint;
    const prevPoint = getPrevPoint(point);
    const afterPoint = getNextPoint(point);
    const { lat, lng } = newPoint;
    let beforeDelta = 1000000;
    if (prevPoint) {
      const beforeDist = getDistance(
        prevPoint.lat,
        prevPoint.lng,
        point.lat,
        point.lng,
        'km'
      );
      const beforeToNewDist = getDistance(
        prevPoint.lat,
        prevPoint.lng,
        lat,
        lng,
        'km'
      );
      beforeDelta = beforeToNewDist / beforeDist;
    }

    let afterDelta = 1000000;
    if (afterPoint) {
      const afterDist = getDistance(
        afterPoint.lat,
        afterPoint.lng,
        point.lat,
        point.lng,
        'km'
      );
      const afterToNewDist = getDistance(
        afterPoint.lat,
        afterPoint.lng,
        lat,
        lng,
        'km'
      );
      afterDelta = afterToNewDist / afterDist;
    } else if (!isExistsEndPoint()) {
      afterDelta = 1;
    }

    if (beforeDelta > afterDelta || afterDelta === 1) {
      return pos;
    }
    return pos - 1;
  };

  const prepareOptions = (newPoint, newPointPos) => {
    const { lat, lng } = newPoint;
    let pathViaStr = '';
    pointStack.forEach((id, it) => {
      const { lat: latP, lng: lngP, isEmpty } = getPointById(id);
      if (!isEmpty) {
        pathViaStr += `${lngP},${latP};`;
      }
      if (it === newPointPos) {
        pathViaStr += `${lng},${lat};`;
      }
    });
    const options = {};
    options.overview = 'simplified';
    if (pathViaStr)
      options.path = pathViaStr.substring(0, pathViaStr.length - 1);

    return options;
  };

  const getListClosePointSettings = (newPoint, getDistance) => {
    const { lat, lng } = newPoint;
    const distsToEachPoint = [];

    pointStack.forEach((id, i) => {
      const point = { ...getPointById(id) };
      if (!point.isEmpty) {
        const dist = getDistance(lat, lng, point.lat, point.lng, 'km');
        distsToEachPoint.push({ dist, point, pos: i });
      }
    });
    distsToEachPoint.sort((a, b) => a.dist - b.dist);

    const newPointPosFirst = getImaginePosition(
      newPoint,
      distsToEachPoint[0],
      getDistance
    );
    const newPointPosSecond = getImaginePosition(
      newPoint,
      distsToEachPoint[1],
      getDistance
    );

    const optionsFirst = prepareOptions(newPoint, newPointPosFirst);
    const optionsSecond = prepareOptions(newPoint, newPointPosSecond);

    return [
      {
        options: optionsFirst,
        point: {
          ...newPoint,
          type: Type.VIA,
          number: newPointPosFirst + 1,
        },
      },
      {
        options: optionsSecond,
        point: {
          ...newPoint,
          type: Type.VIA,
          number: newPointPosSecond + 1,
        },
      },
    ];
  };

  const removeEmptyPoints = () => {
    getStack().forEach((id, pos) => {
      const point = getPointById(id);
      if (point.isEmpty) {
        pointStack.splice(pos, 1);
        delete pointList[id];
      }
    });
  };

  const setPointNumberById = (id, num) => {
    pointList[id].number = num;
    return true;
  };

  const upViaNumbers = (point) => {
    const p = { ...point };
    if (!p.isEmpty) {
      if (p.draggable || p.type !== Type.DRAG) {
        p.number = getPointNumber();
        setPointNumberById(p.getId(), p.number);
      } else {
        delete p.number;
      }
    }
    return p;
  };

  const fixMiddleType = (point, i, len, mode = false) => {
    const p = { ...point };
    if (
      (p.type === Type.START && i !== 0) ||
      (p.type === Type.END && i !== len - 1)
    ) {
      if (mode && mode === twisterType.FreeHand) {
        p.type = Type.DRAG;
        changePointToDragById(p.getId());
      } else {
        p.type = Type.VIA;
        changePointToViaById(p.getId());
      }
    }
    return p;
  };

  const fixPointEnd = async () => {
    if (isEmptyEndPoint()) {
      removePointById(getLastPoint().getId());
    }
    getLastPoint().setType(Type.END);
  };

  const checkDragPointExisting = () =>
    Object.values(pointList).some((point) => point.type === Type.DRAG);

  const isViaWithoutInfoAndMedia = (point) =>
    !point.title &&
    !point.description &&
    (!point.images || point.images.length === 0);

  const changeClearViaToDrag = (point) => {
    if (isViaWithoutInfoAndMedia(point)) {
      point.setType(Type.DRAG);
      upPointOnMap(point);
    }
    return { ...point };
  };

  const getCurrentPartData = (isEmptyAvailable, mode = false) => {
    const len = getCountPoints();
    const isDragPointExists = checkDragPointExisting();

    let prevCoord = '';

    latestPointsList = [];
    lastViaNumber = 0;

    for (let i = 0; i < len; i++) {
      let point = getPointByPos(i);
      if (point) {
        const tmpNumber = point.number;
        const tmpType = point.type;
        const tmpLastOne = point.type;
        point = upViaNumbers(point);
        point = fixMiddleType(point, i, len, mode);

        if (!point.isEmpty) {
          if (point.getType() === Type.VIA || point.getType() === Type.DRAG) {
            point.isLastVia = !getNextPoint(point);
            if (i === len - 1 && !isEmptyAvailable) {
              point.setType(Type.END);
            }
          }
          point.setPrevCoordStr(prevCoord);
          if (
            point &&
            (point.number !== tmpNumber ||
              point.type !== tmpType ||
              point.isLastVia !== tmpLastOne)
          )
            // preven no nedded updating marker on the map
            upPointOnMap(point);
          prevCoord = point.getCoordStr();
        }

        if (!point.isEmpty) {
          if (
            !isEmptyAvailable &&
            !isDragPointExists &&
            point.getType() === Type.VIA
          ) {
            latestPointsList.push(changeClearViaToDrag(point));
          } else {
            latestPointsList.push({ ...point });
          }
        } else if (point.isEmpty && isEmptyAvailable) {
          latestPointsList.push({ ...point });
        }
      }
    }
    return latestPointsList;
  };

  const refreshAllPolylines = () => {
    const len = getCountPoints();
    for (let i = 0; i < len; i++) {
      const point = getPointByPos(i);
      if (point) {
        updatePointPolyOnMap(point);
      }
    }
  };

  const removeIconType = (type) => {
    const len = getCountPoints();
    for (let i = 0; i < len; i++) {
      const point = getPointByPos(i);
      if (point) {
        if (point.iconType === type) delete point.iconType;
      }
    }
  };

  const shallowExtend = (obj1, obj2) => {
    let key;
    for (key in obj2) {
      if ({}.hasOwnProperty.call(obj2, key) === false) {
        continue; // eslint-disable-line
      }
      if (obj2[key]) {
        obj1[key] = obj2[key]; // eslint-disable-line
      }
    }
  };

  const getNextRealPointByPos = (pos) => {
    const nextPointPos = pos + 1;
    const nextPoint = getPointByPos(nextPointPos);
    if (nextPoint) {
      if (!nextPoint.isEmpty) {
        return nextPoint;
      }
      return getNextRealPointByPos(nextPointPos);
    }
    return null;
  };

  const updateNextPointData = (
    id,
    isFixed = false,
    isLoading = false,
    isWithoutReverse = false
  ) => {
    const pos = getPosition(id);
    const point = getPointById(id);
    if (pos < getCountPoints() - 1) {
      const nextPoint = getNextRealPointByPos(pos);
      if (nextPoint && !nextPoint.isEmpty) {
        nextPoint.setPrevCoordStr(point.getCoordStr());
        nextPoint.setPrevId(point.id);
        updatePointPolyOnMap(nextPoint, isFixed, isLoading, isWithoutReverse); // was uncomented
      }
    }
  };

  const getPrevRealPointByPos = (pos) => {
    const prevPointPos = pos - 1;
    const prevPoint = getPointByPos(prevPointPos);
    if (prevPoint) {
      if (!prevPoint.isEmpty) {
        return prevPoint;
      }
      return getPrevRealPointByPos(prevPoint);
    }
    return null;
  };

  const updatePrevPointData = (id, isFixed = false) => {
    const pos = getPosition(id);
    const point = getPointById(id);
    if (pos) {
      const prevPoint = getPrevRealPointByPos(pos);
      if (prevPoint && !prevPoint.isEmpty) {
        point.setPrevCoordStr(prevPoint.getCoordStr());
        prevPoint.setNextId(point.id);
        updatePointPolyOnMap(prevPoint, isFixed); // was uncomented
      }
    }
  };

  const cleanAutocorrectedPoints = () => {
    getStack().forEach((id) => {
      const point = getPointById(id);
      if (!point.isEmpty) {
        point.setAutocorrection(false);
      }
    });
  };

  const updatePointDataById = (id, newPointData, isFromHistory = false) => {
    const newPoint = { ...newPointData };
    const point = getPointById(id);
    /** Keep point position after autocorrection */
    if (isFromHistory && point.isAutocorrection && !newPoint.isAutocorrection) {
      point.keppCurrentCoord = true;
      newPoint.keppCurrentCoord = true;
      newPoint.correctLat = 0; // point.lat;
      newPoint.correctLng = 0; // point.lng;
      point.isAutocorrection = false;
    }
    /** */
    shallowExtend(point, newPoint);
    if (point.iconType === 'none') delete point.iconType;

    if (point.iconType !== newPoint.iconType && newPoint.iconType === undefined)
      removeIconType(point.iconType);

    if (pointList[id].isEmpty && pointList[id].lat && pointList[id].lng) {
      if (isFromHistory && !newPoint.lat && !newPoint.lng) {
        pointList[id].isEmpty = true;
        pointList[id].address = '';
        pointList[id].title = '';
        delete pointList[id].number;
        removePointPolyOnMap(id);
      } else {
        refreshAddressPointById(id);
        pointList[id].isEmpty = false;
        showPointOnMap(pointList[id]);
        stickToRoadPointById(id);
      }
    } else if (!pointList[id].isEmpty) {
      if (isFromHistory) {
        uploadAdditionalPointData(pointList[id]);
      } else {
        refreshAddressPointById(id);
        stickToRoadPointById(id);
      }
    }
    setNextPointCoord(point);
    if (!isFromHistory || point.type === Type.END) updatePointsPrevCoord();
    if (isFromHistory && point.isWrongCoord() && !newPointData.isWrongCoord()) {
      const data = { id, isRemoveCorrectCoord: true };
      setCorrectCoord(data);
      upPointOnMap(pointList[id]);
    }
  };

  const updatePointPosition = (id, index) => {
    if (typeof id !== 'number' || typeof index !== 'number') {
      console.error(`Some param are not a number ${id} or ${index}`);
      return;
    }
    const prevPos = getPosition(id);
    if (prevPos !== index) {
      // then we make a swipe
      const tmpId = pointStack[index];
      pointStack[index] = id;
      pointStack[prevPos] = tmpId;
    }
  };

  const clearStartPointPolyData = () => {
    const point = getFirstPoint();
    point.distance = 0;
    point.duration = 0;
    point.path = '';
  };

  const changePointToStartByPos = (pos) => {
    const id = getStack().splice(pos, 1)[0];
    const startPoint = getPointById(id);
    startPoint.setType(Type.START);
    getStack().unshift(id);

    return { ...startPoint };
  };

  const isEmpty = (point) => (point ? point.isEmpty : false);

  const changePointToEndByPos = (pos) => {
    const id = getStack().splice(pos, 1)[0];
    const endPoint = getPointById(id);
    endPoint.setType(Type.END);
    getStack().push(id);

    return { ...endPoint };
  };

  const fixStartPoint = (
    isEmptyAvailable,
    isStartPointExists = isExistsStartPoint()
  ) => {
    const posEnd = getCountPoints() - 1;
    let isStPointExists = isStartPointExists;
    for (let it = 0; it <= posEnd; it++) {
      const point = getPointByPos(it);
      if (!isStPointExists && !point.isEmpty) {
        if (it === 0 || !point.isEnd()) {
          if (it === 0 && !point.isStart()) {
            point.setType(Type.START);
            upPointOnMap(point);
            isStPointExists = true;
          } else if (it !== posEnd) {
            upPointOnMap(changePointToStartByPos(it));
            isStPointExists = true;
          }
        } else if (isStartPointExists) {
          break;
        }
      }
    }

    if (isEmptyAvailable) {
      if (
        !isStartPointExists &&
        (!getFirstPoint() || !getFirstPoint().isStart())
      ) {
        if (isEmpty(getFirstPoint())) {
          getFirstPoint().setType(Type.START);
        } else {
          setEmptyPoint(Type.START);
        }
      }
    }
  };

  const fixEndPoint = (
    isEmptyAvailable,
    isEndPointExists = isExistsEndPoint()
  ) => {
    const len = getCountPoints();
    const posEnd = len - 1;
    const startPoint = getPointByPos(0);
    for (let it = len; it-- > 0; ) {
      const point = getPointByPos(it);

      const isNeedLookingForLastPoint =
        !isEndPointExists &&
        !point.isEmpty &&
        (!point.isStart() || (it === posEnd && posEnd > 0));

      if (isNeedLookingForLastPoint) {
        if (it === posEnd && !point.isEnd()) {
          if (
            (!point.isLastVia && !point.isAutocorrection) ||
            !startPoint.isLastVia
          ) {
            point.setType(Type.END);
            upPointOnMap(point);
          }
          isEndPointExists = true;
        } else if (it !== 0) {
          upPointOnMap(changePointToEndByPos(it));

          const hasPreLastEmptyPointEndType =
            isEmptyAvailable &&
            pointList[pointStack[posEnd - 1]] &&
            pointList[pointStack[posEnd - 1]].isEmpty &&
            pointList[pointStack[posEnd - 1]].type === Type.END;
          if (hasPreLastEmptyPointEndType) {
            delete pointList[pointStack[posEnd - 1]];
            pointStack.splice(posEnd - 1, 1);
          }
          isEndPointExists = true;
        }
      } else if (isEndPointExists) {
        break;
      }
    }

    if (isEmptyAvailable) {
      if (!isEndPointExists && (!getLastPoint() || !getLastPoint().isEnd())) {
        if (getLastPoint() && getLastPoint().isEmpty && posEnd > 0) {
          getLastPoint().setType(Type.END);
        } else {
          setEmptyPoint(Type.VIA);
          setEmptyPoint(Type.END);
        }
      }
    }
  };

  const fixPointTypes = (
    isEmptyAvailable,
    isStartPointExists,
    isEndPointExists
  ) => {
    fixStartPoint(isEmptyAvailable, isStartPointExists);
    fixEndPoint(isEmptyAvailable, isEndPointExists);
  };

  const reverse = (isEditable) => {
    getStack().reverse();
    clearStartPointPolyData();
    updatePointsPrevCoord();
    fixPointTypes(isEditable);
    const point = getFirstPoint();
    point.isLastVia = false;
  };

  const convertTypeTo = (type, point, isLastBehind) => {
    if (type === Type.VIA || type === Type.DRAG) {
      if (isLastBehind && type === Type.VIA) {
        if (point.getType() === Type.END) getLastPoint().setType(Type.VIA);
        setEmptyPoint(Type.END);
      } else {
        setEmptyPoint(point.getType());
      }
      point.setType(type);
      upPointOnMap(point);
    } else {
      reverse(isLastBehind);
    }
  };

  const convertViaTo = (type, id, isLastBehind) => {
    const posDrag = getPosition(id);
    const dragId = pointStack.splice(posDrag, 1)[0];
    let posEnd = 0;
    if (type === Type.START) {
      pointStack.splice(0, 0, dragId);
      posEnd = 1;
    } else if (type === Type.END) {
      pointStack.push(dragId);
      posEnd = getCountPoints() - 2;
      removeEmptyPoints();
    } else {
      pointStack.splice(posDrag, 0, dragId);
    }

    const dragPoint = getPointById(dragId);
    const endPosPoint = getPointByPos(posEnd);

    delete dragPoint.number;
    delete endPosPoint.number;
    delete endPosPoint.isLastVia;

    dragPoint.setType(type);
    endPosPoint.setType(Type.VIA);

    updatePointsPrevCoord();
    const isExistStart = type === Type.END ? true : isExistsStartPoint();
    fixPointTypes(true, isExistStart);

    upPointOnMap(endPosPoint);
    upPointOnMap(dragPoint);

    if (type === Type.START) {
      updatePointPolyOnMap(endPosPoint);
      const nextPoint = getNextPoint(endPosPoint);
      updatePointPolyOnMap(nextPoint);
      updatePointPolyOnMap(dragPoint);
      updatePointPolyOnMap(getPointByPos(posDrag + 1));
    } else if (type === Type.END && !isLastBehind) {
      updatePointPolyOnMap(dragPoint);
      updatePointPolyOnMap(endPosPoint);
      if (posDrag < posEnd) {
        updatePointPolyOnMap(getPointByPos(posDrag));
      }
    }
  };

  const existedIds = (img) => {
    return !!(img && img.id && img.id > 0);
  };

  const updatePointMediaById = (id, images) => {
    const point = getPointById(id);
    point.images = images;
    const ids = images.filter(existedIds).map((img) => img.id);
    point.imgids = ids.join();
  };

  const updatePointRoutePathById = (id, { path, distance, duration }) => {
    const point = getPointById(id);
    if (point) {
      point.encodedpath = path;
      point.distance = distance;
      point.duration = duration;
    }
  };

  const updateTitleAndDesc = (id, title, desc) => {
    const point = getPointById(id);
    point.title = title;
    point.description = desc;
  };

  const setPointTypeById = (
    id,
    type,
    isLastBehind = false,
    switcher = false
  ) => {
    const point = getPointById(id);
    if (!point) console.error(`Point with id ${id} is not exists`);

    if (
      point.iconType === `${Type.HOME}_${Type.END}` ||
      point.iconType === `${Type.HOME}_${Type.START}` ||
      point.iconType === `${Type.WORK}_${Type.END}` ||
      point.iconType === `${Type.WORK}_${Type.START}`
    ) {
      point.iconType = undefined;
    }

    if (switcher) return;

    if (point.isStart() || point.isEnd())
      convertTypeTo(type, point, isLastBehind);
    else convertViaTo(type, id, isLastBehind);
  };

  const getPrevPointPos = (point) => {
    if (point) {
      const pos = getPosition(point.getId()) - 1;
      const prevPoint = getPointByPos(pos);
      if (prevPoint && prevPoint.isEmpty) {
        return getPrevPointPos(prevPoint);
      }
      return pos;
    }
    return null;
  };

  const removePoint = (id) => {
    const point = { ...getPointById(id) };
    if (point) {
      const nextPoint = getNextPoint(point);
      const prevPoint = getPrevPoint(point);
      removePointById(id);
      if (nextPoint) {
        setPointSiblings(nextPoint, getPrevPointPos(nextPoint));
        updatePointPolyOnMap({ ...nextPoint, isRemoved: true });
      }
      if (!nextPoint) {
        getMediator().notify(e.TB_CLEAR_DELETE_DELAY);
      }
      updatePointsPrevCoord();
      fixPointTypes(true, isExistsStartPoint(), true);
      if (nextPoint) {
        return nextPoint.id;
      }
      if (prevPoint) {
        return prevPoint.id;
      }
      return 0;
    }
    return false;
  };

  const getRightPointsStack = (pos) => {
    const len = pointStack.length;
    return pointStack.splice(pos + 1, len - (pos + 1));
  };

  const upPointsList = (nextPartStack) => {
    const nextPartList = {};
    nextPartStack.forEach((id) => {
      nextPartList[id] = { ...pointList[id] };
      delete pointList[id];
    });
    return nextPartList;
  };

  const preparePoints = (partStack, partList) => {
    const len = partStack.length;
    let lastViaNum = 0;
    const latePointsList = [];
    for (let i = 0; i < len; i++) {
      const point = partList[partStack[i]];
      if (point) {
        if (i > 0 && point.getType() !== Type.END) {
          point.number = ++lastViaNum;
        }

        if (!point.isEmpty) {
          latePointsList.push({ ...point });
        }
      }
    }

    return latePointsList;
  };

  const cutSecondRoutePartByPointId = (id) => {
    const point = getPointById(id);
    if (
      point &&
      point.getType() !== Type.START &&
      point.getType() !== Type.END
    ) {
      const pos = getPosition(id);
      if (pos > 0) {
        const nextPartStack = getRightPointsStack(pos);
        const nextPartList = upPointsList(nextPartStack);

        nextPartStack.unshift(id);
        const doublePoint = { ...point };

        doublePoint.setType(Type.START);
        doublePoint.unique_id = 0;

        nextPartList[id] = doublePoint;

        point.setType(Type.END);

        const points = preparePoints(nextPartStack, nextPartList);

        return { nextPartStack, points };
      }
      console.info(`wrong position - ${pos}`);
    } else {
      console.info(
        `We can not devide route by point with type - ${point.getType()}`
      );
      return false;
    }
    return false;
  };

  const detectPointPosBefore = (nextId) =>
    nextId ? getPosition(nextId) - 1 : 0;

  const getNextWrongRoutePosition = (point) => {
    const pos = getPosition(point.id);
    if (!pos || pos >= getCountPoints()) return null;

    const nextPoint = getPointByPos(pos + 1);
    if (!nextPoint) {
      return null;
    }
    if (nextPoint && nextPoint.isWrongCoord()) {
      return nextPoint.getLatLng();
    }
    return getNextWrongRoutePosition(nextPoint);
  };

  const exchangePositionByPointId = ({ pointId, direction }) => {
    const point = getPointById(pointId);
    if (point) {
      const sibling =
        direction === 'next' ? getNextPoint(point) : getPrevPoint(point);
      if (sibling) {
        const { lat: correctLat, lng: correctLng, keppCurrentCoord } = point;
        sibling.setCorrectCoord({
          correctLat,
          correctLng,
          keppCurrentCoord,
        });
        const siblingData = {
          correctLat: sibling.lat,
          correctLng: sibling.lng,
          keppCurrentCoord: sibling.keppCurrentCoord,
        };
        point.setCorrectCoord(siblingData);

        // const nextPoint = getNextPoint(point);
        // if(nextPoint){
        //     const {lat:correctLat, lng: correctLng, keppCurrentCoord} = point;
        //     nextPoint.setCorrectCoord({correctLat, correctLng, keppCurrentCoord});
        //     const nextPintData = {
        //         correctLat: nextPoint.lat,
        //         correctLng: nextPoint.lng,
        //         keppCurrentCoord: nextPoint.keppCurrentCoord,
        //     }
        //     point.setCorrectCoord(nextPintData);
        // prevPoint.setNextId(point.getNextId());
        // prevPoint.setPrevId(point.getId());
        // prevPoint.setCoordStr(point.getCoordStr());

        // point.setPrevId(prevPoint.getPrevId());
        // point.setNextId(prevPoint.getId());
        // point.setPrevCoordStr(prevPoint.getCoordStr());

        // prevPoint.correctPointPosition(point.lat, point.lng);
        // point.correctPointPosition(prevPoint.lat, prevPoint.lng);

        // updatePointPolyOnMap({...prevPoint}, true);
        // updatePointPolyOnMap({...point}, true);
      }
    }
  };
  const isEnd = (point) =>
    point && typeof point.isEnd === 'function' && point.isEnd();
  const isStart = (point) =>
    point && typeof point.isStart === 'function' && point.isStart();

  const movePoint = (id, index, isLoading = false) => {
    const isEndPointExists = isExistsEndPoint();
    const isStartPointExists = isExistsStartPoint();
    const pos = getPosition(id);
    const pt = getPointByPos(index);
    const dr = getPointByPos(pos);
    if (pointStack.length === index + 1) {
      if (isEnd(pt)) {
        let type = dr.type || Type.VIA;
        if (type === Type.START) type = Type.VIA;
        pt.setType(type);
      }
    } else if (isEnd(dr)) {
      const type = pt.type || Type.VIA;
      if (type === Type.START && index === 0) {
        getPointByPos(index).setType(Type.VIA);
      }
      dr.setType(type);
    } else if (isStart(dr)) {
      const type = pt.type || Type.VIA;
      dr.setType(type);
    } else if (isStart(pt)) {
      const type = dr.type || Type.VIA;
      pt.setType(type);
    }

    const draggedPoint = pointStack.splice(pos, 1);
    pointStack.splice(index, 0, draggedPoint[0]);
    updatePointsPrevCoord();

    fixPointTypes(true, !isStartPointExists, !isEndPointExists);

    const point = getPointById(id);
    if (!point || point.isEmpty) {
      return [];
    }

    updatePointPolyOnMap(point, false, isLoading);

    const nextPoint = getNextPoint(point);
    updatePointPolyOnMap(nextPoint);
    updatePointPolyOnMap(getNextPoint(nextPoint));

    updateNextPointData(id, false, isLoading);

    const listPointIds = index - pos === 1 || pos - index === 1 ? [id] : [];
    const beforePrevPointFromPastPlace = getPrevRealPointByPos(pos - 1);
    const prevPointFromPastPlace = getPrevRealPointByPos(pos);
    const nextPointFromPastPlace = getNextRealPointByPos(pos);
    const nextNextPointFromPastPlace = getNextRealPointByPos(pos + 1);
    if (beforePrevPointFromPastPlace)
      updateNextPointData(
        beforePrevPointFromPastPlace.getId(),
        false,
        isLoading
      );
    if (prevPointFromPastPlace) {
      updateNextPointData(prevPointFromPastPlace.getId(), false, isLoading);
    }
    if (nextPointFromPastPlace) {
      updateNextPointData(nextPointFromPastPlace.getId(), false, isLoading);
    }
    if (nextNextPointFromPastPlace)
      updateNextPointData(nextNextPointFromPastPlace.getId(), false, isLoading);

    return listPointIds;
  };

  const clear = () => {
    pointList = {};
    pointStack = [];
  };
  const destroy = () => {
    clear();
    destroyMediator();
  };

  return Object.freeze({
    setMediator,
    clear,
    destroy,
    reverse,
    movePoint,
    refreshAllPolylines,
    removePoint,
    fixPointTypes,
    wasPolyChanged,
    detectPointPosBefore,
    isCurrPartCompleted,
    isPointExists,
    hasTourPoly,
    getNextPoint,
    getPrevPoint,
    getPointById,
    getCountPoints,
    getExcessPoints,
    getListClosePointSettings,
    getCurrentPartData,
    getNextPointType,
    setPointTypeById,
    addPointByType,
    updatePointDataById,
    updatePointPosition,
    updateNextPointData,
    updateTitleAndDesc,
    updatePointMediaById,
    updatePointRoutePathById,
    removeIconType,
    removeEmptyPoints,
    isExistsEndPoint,
    isIndexBeforeLastVia,
    isExistsStartPoint,
    updatePrevPointData,
    setCorrectCoord,
    setCoordRelation,
    getNextWrongRoutePosition,
    updateAllPointsRelation,
    correctPointsPositions,
    getLastNotEmptyPoint,
    exchangePositionByPointId,
    cleanAutocorrectedPoints,
    onlyPointsWithShortestWrongDist,
    getPointTypeById,
    cutSecondRoutePartByPointId,
    getFirstPoint,
    fixPointEnd,
    removePointById,
    getStack,
    getList,

    // updatePointsPrevCoord,
    // stickToRoadPointById,
    // refreshAddressPointById,
  });
};

export default PartData;
